import React, {useEffect} from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import GoogleLoginComponent from './Components/GoogleLoginComponent';
import HomeLayout from './Components/HomeLayout';
import Home from './Components/Home';
import TripWrapper from './Components/Trips/TripWrapper';
import './App.css';
import { GoogleOAuthProvider } from '@react-oauth/google';
import ProtectedRoute from './Components/ProtectedRoute';
import { useUser } from './Components/userContext';
import useCheckLogin from './Components/CustomHooks/useCheckLogin';
import { setLogoutFunction } from './api/apiClient';
import LoadingOverlay from './LoadingOverlay';
import ScrollToTop from './ScrollToTop';
import { ToastProvider } from './Contexts/ToastContext';
import Toast from './Components/Toast';
import UsersManager from './Components/Users/UsersManager';
import { canSeeUsers, canAccessViews } from './utils/permissions';
import ViewsDashboardWrapper from './Components/ViewsDashboard/ViewsDashboardWrapper';

const App = () => {
  const { user, setUser, logout } = useUser();
  const isLoading = useCheckLogin();
  
  useEffect(() => {
    setLogoutFunction(logout);
  }, [logout]);

  if (isLoading) {
    return <LoadingOverlay text="Ładowanie aplikacji..." />;
  }

  document.title = process.env.REACT_APP_TITLE || "Aplikacja Koordynatorska";

  return (
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
      <ToastProvider>
        <Router>
          <Toast />
          <ScrollToTop />
          <Routes>
            <Route
              path="/login"
              element={user? <Navigate to="/" replace /> : <GoogleLoginComponent setUser={setUser}/>}
            />

            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <HomeLayout user={user} />
                </ProtectedRoute>
              }
            >
              <Route index element={<Home />} /> 
              <Route path="trips/:guid/*" element={<TripWrapper />} />
              {canSeeUsers(user) && (<Route path="/users" element={<UsersManager />} /> )}
              {canAccessViews(user) && (<Route path="views/*" element={<ViewsDashboardWrapper   />} />)}
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Router>
      </ToastProvider>
    </GoogleOAuthProvider>
  );
};

export default App;
